(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageFor = (frequency) => (frequency === 'forever' ? window.localStorage : window.sessionStorage);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const clearRotation = (bar) => {
      if (!bar.dataset.rotationTimer) return;
      window.clearInterval(Number(bar.dataset.rotationTimer));
      delete bar.dataset.rotationTimer;
    };

    const setActiveItem = (items, nextIndex) => {
      items.forEach((item, index) => {
        const isActive = index === nextIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (item.matches('a')) {
          if (isActive) {
            item.removeAttribute('tabindex');
          } else {
            item.setAttribute('tabindex', '-1');
          }
        }
      });
    };

    const setupRotation = (bar) => {
      clearRotation(bar);

      if (bar.dataset.layout !== 'static' || bar.dataset.autoplay !== 'true' || reducedMotion.matches) return;

      const items = Array.from(bar.querySelectorAll('.announcement-bar__item:not([aria-hidden="true"])'));
      if (items.length < 2) return;

      let activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;
      setActiveItem(items, activeIndex);

      const interval = Math.max(Number(bar.dataset.slideInterval) || 5000, 2000);
      const rotate = () => {
        activeIndex = (activeIndex + 1) % items.length;
        setActiveItem(items, activeIndex);
      };
      const start = () => {
        clearRotation(bar);
        bar.dataset.rotationTimer = window.setInterval(rotate, interval);
      };

      bar.addEventListener('mouseenter', clearRotation.bind(null, bar));
      bar.addEventListener('focusin', clearRotation.bind(null, bar));
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusout', start);

      start();
    };

    const initAnnouncementBars = () => {
      document.querySelectorAll('[data-announcement-bar]').forEach((bar) => {
        if (bar.dataset.initialized === 'true') return;
        bar.dataset.initialized = 'true';

        const key = bar.dataset.storageKey;
        const dismissEnabled = bar.dataset.enableDismiss === 'true';
        const storage = storageFor(bar.dataset.dismissFrequency);

        if (dismissEnabled && key && storage.getItem(key) === 'dismissed') {
          bar.hidden = true;
          return;
        }

        const dismiss = bar.querySelector('[data-announcement-dismiss]');
        if (dismiss) {
          dismiss.addEventListener('click', () => {
            if (key) storage.setItem(key, 'dismissed');
            clearRotation(bar);
            bar.hidden = true;
            document.dispatchEvent(new CustomEvent('announcement-bar:dismissed'));
          });
        }

        setupRotation(bar);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAnnouncementBars);
    } else {
      initAnnouncementBars();
    }

    document.addEventListener('shopify:section:load', initAnnouncementBars);
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-announcement-bar]').forEach(clearRotation);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tabbed-products]').forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[data-tabbed-products-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-tabbed-products-panel]'));

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const activeIndex = tab.dataset.tabbedProductsTab;

        tabs.forEach((item) => {
          const isActive = item.dataset.tabbedProductsTab === activeIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', String(isActive));
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.tabbedProductsPanel === activeIndex;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    document.querySelectorAll('form.localization-switcher').forEach(function (form) {
      if (form.dataset.localizationInitialized === 'true') return;
      form.dataset.localizationInitialized = 'true';

      form.querySelectorAll('select').forEach(function (select) {
        select.addEventListener('change', function () {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });

      var btn = form.querySelector('.localization-switcher__submit');
      if (btn) btn.hidden = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-site-header]').forEach((header) => {
    if (header.dataset.megaMenuInitialized === 'true') return;
    header.dataset.megaMenuInitialized = 'true';

    const megaItems = Array.from(header.querySelectorAll('.site-header__nav-item--mega'));
    const drawer = header.querySelector('.site-header__drawer');
    const drawerGroups = Array.from(header.querySelectorAll('.site-header__drawer-group'));
    const searchPopover = header.querySelector('.site-header__search-popover');
    const searchForm = header.querySelector('[data-header-search-form]');
    const searchInput = header.querySelector('[data-header-search-input]');
    const searchClose = header.querySelector('[data-header-search-close]');
    const searchTerms = header.querySelector('[data-header-search-terms]');
    const searchProducts = header.querySelector('[data-header-search-products]');
    const searchFallbackProductsScript = header.querySelector('[data-header-search-fallback-products]');
    const searchCuratedProductsScript = header.querySelector('[data-header-search-curated-products]');
    const searchEmpty = header.querySelector('[data-header-search-empty]');
    const searchResults = header.querySelector('[data-header-search-results]');
    const defaultSearchTerms = searchTerms
      ? Array.from(searchTerms.querySelectorAll('a')).map((link) => link.textContent.trim()).filter(Boolean)
      : [];
    const parseSearchProducts = (script) => {
      if (!script) return [];
      try {
        return JSON.parse(script.textContent || '[]');
      } catch (error) {
        return [];
      }
    };
    const fallbackSearchProducts = [
      ...parseSearchProducts(searchFallbackProductsScript),
      ...parseSearchProducts(searchCuratedProductsScript),
    ];
    let searchAbortController = null;
    let searchDebounceTimer = null;

    header.querySelectorAll('form.localization-switcher').forEach((form) => {
      if (form.dataset.localizationInitialized === 'true') return;
      form.dataset.localizationInitialized = 'true';

      form.querySelectorAll('select').forEach((select) => {
        select.addEventListener('change', () => {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });

      const submit = form.querySelector('.localization-switcher__submit');
      if (submit) submit.hidden = true;
    });

    const closeAll = () => {
      megaItems.forEach((item) => item.classList.remove('is-open'));
    };

    const closeDrawerGroups = () => {
      drawerGroups.forEach((group) => {
        group.open = false;
      });
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.open = false;
      closeDrawerGroups();
      document.documentElement.classList.remove('site-header-drawer-open');
    };

    const syncDrawerTop = () => {
      const headerBottom = header.getBoundingClientRect().bottom;
      header.style.setProperty('--site-header-drawer-top', `${Math.max(0, Math.round(headerBottom))}px`);
    };

    const closeSearch = () => {
      if (!searchPopover) return;
      searchPopover.open = false;
      document.documentElement.classList.remove('site-header-search-open');
    };

    const setSearchEmpty = (message, show = true) => {
      if (!searchEmpty) return;
      searchEmpty.textContent = message;
      searchEmpty.hidden = !show;
    };

    const formatSearchPrice = (value) => {
      if (value === undefined || value === null || value === '') return '';
      if (typeof value === 'string') return value;

      const currency = window.Shopify?.currency?.active || 'USD';
      const locale = document.documentElement.lang || 'en';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
        }).format(value / 100);
      } catch (error) {
        return `$${(value / 100).toFixed(2)}`;
      }
    };

    const updateSearchTerms = (query) => {
      if (!searchTerms || !searchForm) return;

      const searchUrl = searchForm.getAttribute('action') || '/search';
      const queryIncludesHockey = query.toLowerCase().includes('hockey');
      const rawTerms = query
        ? [
            query,
            queryIncludesHockey ? `${query} sticks` : `${query} hockey`,
            `${query} sale`,
            `${query} skates`,
            `${query} junior`,
          ]
        : defaultSearchTerms;
      const terms = Array.from(
        new Map(rawTerms.map((term) => [term.trim().toLowerCase(), term.trim()])).values()
      ).filter(Boolean).slice(0, 5);

      searchTerms.replaceChildren();

      terms.forEach((term, index) => {
        const link = document.createElement('a');
        link.href = `${searchUrl}?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(term)}`;
        link.textContent = term;

        if (index === 0) {
          link.dataset.current = 'true';
        }

        searchTerms.append(link);
      });
    };

    const updateSearchResultsLink = (query) => {
      if (!searchResults || !searchForm) return;

      const trimmedQuery = query.trim();
      const searchUrl = searchForm.getAttribute('action') || '/search';

      if (!trimmedQuery) {
        searchResults.hidden = true;
        searchResults.href = `${searchUrl}?type=product&options%5Bprefix%5D=last`;
        return;
      }

      const label = searchResults.dataset.resultsTemplate || 'See results for "__TERMS__"';
      const labelText = label.replace('__TERMS__', trimmedQuery);
      const labelNode = searchResults.querySelector('span');

      if (labelNode) {
        labelNode.textContent = labelText;
      }

      searchResults.href = `${searchUrl}?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(trimmedQuery)}`;
      searchResults.hidden = false;
    };

    const renderSearchProducts = (products) => {
      if (!searchProducts) return;

      searchProducts.replaceChildren();

      products.forEach((product) => {
        const card = document.createElement('a');
        card.className = 'site-header__search-product';
        card.href = product.url || '#';

        const imageUrl = product.featured_image?.url || product.image || product.featured_image;

        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = product.featured_image?.alt || product.title || '';
          image.loading = 'lazy';
          card.append(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'site-header__search-product-placeholder';
          card.append(placeholder);
        }

        const title = document.createElement('strong');
        title.textContent = product.title || '';
        card.append(title);

        const priceValue = product.price || product.price_min || product.min_price;
        const priceText = formatSearchPrice(priceValue);

        if (priceText) {
          const price = document.createElement('span');
          price.textContent = priceText;
          card.append(price);
        }

        searchProducts.append(card);
      });
    };

    const getFallbackSearchProducts = (query) => {
      const trimmedQuery = query.trim().toLowerCase();

      if (!fallbackSearchProducts.length) return [];
      if (!trimmedQuery) return fallbackSearchProducts.slice(0, 10);

      const tokens = trimmedQuery.split(/\s+/).filter(Boolean);
      const matchingProducts = fallbackSearchProducts.filter((product) => {
        const title = (product.title || '').toLowerCase();
        return tokens.every((token) => title.includes(token));
      });

      return (matchingProducts.length ? matchingProducts : fallbackSearchProducts).slice(0, 10);
    };

    const runPredictiveSearch = async (query) => {
      if (!searchForm || !searchProducts) return;

      const trimmedQuery = query.trim();
      updateSearchTerms(trimmedQuery);
      updateSearchResultsLink(trimmedQuery);

      if (searchAbortController) {
        searchAbortController.abort();
      }

      if (!trimmedQuery) {
        renderSearchProducts([]);
        setSearchEmpty(searchEmpty?.dataset.startMessage || 'Start typing to see product suggestions.');
        return;
      }

      searchAbortController = new AbortController();
      setSearchEmpty(searchEmpty?.dataset.loadingMessage || 'Loading suggestions...');

      const endpoint = `${searchForm.getAttribute('action') || '/search'}/suggest.json?q=${encodeURIComponent(trimmedQuery)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;

      try {
        const response = await fetch(endpoint, {
          signal: searchAbortController.signal,
          headers: {
            Accept: 'application/json',
          },
        });

        if (!response.ok) throw new Error('Predictive search request failed');

        const data = await response.json();
        const products = data?.resources?.results?.products || [];
        const productsToRender = products.length ? products : getFallbackSearchProducts(trimmedQuery);
        renderSearchProducts(productsToRender);
        setSearchEmpty(productsToRender.length ? '' : searchEmpty?.dataset.emptyMessage || 'No product suggestions found.', !productsToRender.length);
      } catch (error) {
        if (error.name === 'AbortError') return;
        const fallbackProducts = getFallbackSearchProducts(trimmedQuery);
        renderSearchProducts(fallbackProducts);
        setSearchEmpty(fallbackProducts.length ? '' : searchEmpty?.dataset.errorMessage || 'Search suggestions are not available right now.', !fallbackProducts.length);
      }
    };

    const queuePredictiveSearch = () => {
      if (!searchInput) return;

      window.clearTimeout(searchDebounceTimer);
      searchDebounceTimer = window.setTimeout(() => {
        runPredictiveSearch(searchInput.value);
      }, 160);
    };

    megaItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        closeAll();
        item.classList.add('is-open');
      });

      item.addEventListener('mouseleave', () => {
        item.classList.remove('is-open');
      });

      item.addEventListener('focusin', () => {
        closeAll();
        item.classList.add('is-open');
      });

      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) {
          item.classList.remove('is-open');
        }
      });
    });

    if (drawer) {
      const mobileQuery = window.matchMedia('(max-width: 900px)');

      drawer.addEventListener('toggle', () => {
        syncDrawerTop();
        document.documentElement.classList.toggle('site-header-drawer-open', drawer.open);

        if (drawer.open && searchPopover) {
          searchPopover.open = false;
        }

        if (!drawer.open) {
          closeDrawerGroups();
        }
      });

      drawer.querySelectorAll('.site-header__drawer-panel a').forEach((link) => {
        link.addEventListener('click', closeDrawer);
      });

      drawerGroups.forEach((group) => {
        group.addEventListener('toggle', () => {
          if (!group.open) return;

          drawerGroups.forEach((otherGroup) => {
            if (otherGroup !== group) {
              otherGroup.open = false;
            }
          });
        });
      });

      const syncDrawerBreakpoint = () => {
        syncDrawerTop();

        if (!mobileQuery.matches) {
          closeDrawer();
        }
      };

      syncDrawerBreakpoint();

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', syncDrawerBreakpoint);
      } else {
        mobileQuery.addListener(syncDrawerBreakpoint);
      }

      window.addEventListener('resize', syncDrawerTop);
      window.addEventListener('scroll', syncDrawerTop, { passive: true });
      document.addEventListener('announcement-bar:dismissed', syncDrawerTop);
    }

    if (searchPopover) {
      searchPopover.addEventListener('toggle', () => {
        document.documentElement.classList.toggle('site-header-search-open', searchPopover.open);

        if (searchPopover.open) {
          syncDrawerTop();
          closeDrawer();
          const initialSearchQuery = searchInput?.value || '';
          updateSearchTerms(initialSearchQuery);
          updateSearchResultsLink(initialSearchQuery);

          if (initialSearchQuery.trim()) {
            runPredictiveSearch(initialSearchQuery);
          } else {
            const initialProducts = getFallbackSearchProducts('');
            renderSearchProducts(initialProducts);
            setSearchEmpty(
              searchEmpty?.dataset.startMessage || 'Start typing to see product suggestions.',
              !initialProducts.length
            );
          }

          window.requestAnimationFrame(() => {
            searchInput?.focus();
          });
        } else {
          document.documentElement.classList.remove('site-header-search-open');
        }
      });

      searchClose?.addEventListener('click', closeSearch);

      searchInput?.addEventListener('input', queuePredictiveSearch);

      searchPopover.addEventListener('click', (event) => {
        if (!searchPopover.open) return;
        if (event.target === searchPopover) {
          closeSearch();
        }
      });

      document.addEventListener('click', (event) => {
        if (!searchPopover.open || searchPopover.contains(event.target)) return;
        closeSearch();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAll();
        closeDrawer();
        closeSearch();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cart-page]').forEach((section) => {
    if (section.dataset.cartPageInitialized === 'true') return;
    section.dataset.cartPageInitialized = 'true';

    const form = section.querySelector('.cart-page__form');
    const status = section.querySelector('[data-cart-page-status]');
    const countLabel = section.querySelector('[data-cart-page-count-label]');
    const subtotal = section.querySelector('[data-cart-page-subtotal]');
    const total = section.querySelector('[data-cart-page-total]');
    const mobileTotal = section.querySelector('[data-cart-page-mobile-total]');
    const ajaxEnabled = section.dataset.ajaxCart === 'true' && typeof window.fetch === 'function';
    const rootUrl = section.dataset.rootUrl || window.Shopify?.routes?.root || '/';
    const routesRoot = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
    const changeUrl = `${routesRoot}cart/change.js`;
    const labels = {
      updating: section.dataset.updatingLabel || 'Updating cart',
      updated: section.dataset.updatedLabel || '',
      error: section.dataset.errorLabel || 'Something went wrong. Please try again.',
      oneTemplate: section.dataset.countOneTemplate || '[count] item',
      otherTemplate: section.dataset.countOtherTemplate || '[count] items',
    };
    let activeRequest = Promise.resolve();
    let statusTimer = null;

    const formatMoney = (amount, currency) => {
      const activeCurrency = currency || section.dataset.currency || 'USD';

      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: activeCurrency,
        }).format(Number(amount || 0) / 100);
      } catch (error) {
        return `${activeCurrency} ${(Number(amount || 0) / 100).toFixed(2)}`;
      }
    };

    const formatCount = (count) => {
      const template = Number(count) === 1 ? labels.oneTemplate : labels.otherTemplate;
      return template.replace('[count]', String(count));
    };

    const setStatus = (message = '', isError = false) => {
      if (!status) return;

      window.clearTimeout(statusTimer);
      status.textContent = message;
      status.classList.toggle('is-error', Boolean(isError));

      if (message && !isError) {
        statusTimer = window.setTimeout(() => {
          status.textContent = '';
        }, 1800);
      }
    };

    const setUpdating = (isUpdating) => {
      section.classList.toggle('is-updating', isUpdating);
      section.setAttribute('aria-busy', isUpdating ? 'true' : 'false');

      section.querySelectorAll('[data-cart-quantity-step], [data-cart-quantity-input], [data-cart-page-remove], .cart-page__update').forEach((control) => {
        if ('disabled' in control) {
          control.disabled = isUpdating;
        } else {
          control.toggleAttribute('aria-disabled', isUpdating);
        }
      });
    };

    const updateCartCount = (count) => {
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.textContent = String(count);
        badge.hidden = count === 0;
      });
    };

    const renderCart = (cart) => {
      const itemCount = Number(cart.item_count || 0);
      const currency = cart.currency || section.dataset.currency;

      if (itemCount === 0) {
        window.location.reload();
        return;
      }

      const itemMap = new Map((cart.items || []).map((item) => [item.key, item]));

      section.querySelectorAll('[data-cart-page-line]').forEach((line) => {
        const item = itemMap.get(line.dataset.key);

        if (!item) {
          line.remove();
          return;
        }

        const input = line.querySelector('[data-cart-quantity-input]');
        const linePrice = line.querySelector('[data-cart-page-line-price]');

        if (input) {
          input.value = String(item.quantity);
          input.dataset.lastQuantity = String(item.quantity);
        }

        if (linePrice) {
          linePrice.textContent = formatMoney(item.final_line_price, currency);
        }

        line.classList.remove('is-updating');
      });

      if (countLabel) {
        countLabel.textContent = formatCount(itemCount);
      }

      if (subtotal) {
        subtotal.textContent = formatMoney(cart.items_subtotal_price, currency);
      }

      if (total) {
        total.textContent = formatMoney(cart.total_price, currency);
      }

      if (mobileTotal) {
        mobileTotal.textContent = formatMoney(cart.total_price, currency);
      }

      updateCartCount(itemCount);
      document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: { cart } }));
    };

    const requestLineUpdate = (line, quantity) => {
      if (!line) {
        form?.requestSubmit?.();
        return;
      }

      const input = line.querySelector('[data-cart-quantity-input]');
      const previousQuantity = Number(input?.dataset.lastQuantity || input?.defaultValue || input?.value || 1);
      const nextQuantity = Math.max(0, Number(quantity || 0));

      if (input) {
        input.value = String(nextQuantity);
      }

      if (!ajaxEnabled || !line?.dataset.key) {
        form?.requestSubmit?.();
        return;
      }

      line.classList.add('is-updating');
      setUpdating(true);
      setStatus(labels.updating);

      activeRequest = activeRequest
        .catch(() => {})
        .then(async () => {
          const response = await window.fetch(changeUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: line.dataset.key,
              quantity: nextQuantity,
            }),
          });
          const payload = await response.json().catch(() => null);

          if (!response.ok || !payload) {
            throw new Error(payload?.description || payload?.message || labels.error);
          }

          renderCart(payload);
          setStatus(labels.updated);
        })
        .catch((error) => {
          if (input) {
            input.value = String(previousQuantity);
          }

          line.classList.remove('is-updating');
          setStatus(error.message || labels.error, true);
        })
        .finally(() => {
          setUpdating(false);
        });
    };

    if (ajaxEnabled) {
      section.classList.add('cart-page--ajax-ready');
      section.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
        input.dataset.lastQuantity = input.value;
      });
    }

    section.querySelectorAll('[data-cart-quantity-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const control = button.closest('.cart-page__quantity-control');
        const input = control?.querySelector('[data-cart-quantity-input]');
        if (!input) return;

        const step = Number(button.dataset.cartQuantityStep);
        const currentValue = Number.parseInt(input.value, 10) || 0;
        const nextValue = Math.max(0, currentValue + step);
        const line = button.closest('[data-cart-page-line]');

        requestLineUpdate(line, nextValue);
      });
    });

    section.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
      input.addEventListener('change', () => {
        const line = input.closest('[data-cart-page-line]');
        const nextValue = Math.max(0, Number.parseInt(input.value, 10) || 0);

        requestLineUpdate(line, nextValue);
      });
    });

    section.querySelectorAll('[data-cart-page-remove]').forEach((removeLink) => {
      removeLink.addEventListener('click', (event) => {
        const line = removeLink.closest('[data-cart-page-line]');
        if (!ajaxEnabled || !line) return;

        event.preventDefault();
        requestLineUpdate(line, 0);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const catalogSelector = '.collection-catalog[data-ajax-catalog]';
    const initializedCatalogs = new WeakSet();

    const getFormUrl = (form) => {
      const url = new URL(form.getAttribute('action') || window.location.href, window.location.href);
      url.search = new URLSearchParams(new FormData(form)).toString();
      return url.href;
    };

    const loadCatalogAssets = async (doc) => {
      doc.querySelectorAll('link[rel="stylesheet"][href*="compiled_assets/styles.css"]').forEach((link) => {
        const href = link.href;
        if (!href || document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) return;
        document.head.append(link.cloneNode(false));
      });

      const scriptLoads = Array.from(doc.querySelectorAll('script[src*="compiled_assets/scripts.js"]')).map((script) => {
        const src = script.src;
        if (!src || document.querySelector(`script[src="${src}"]`)) {
          return Promise.resolve();
        }

        return new Promise((resolve) => {
          const clone = document.createElement('script');
          clone.src = src;
          clone.async = false;
          clone.onload = resolve;
          clone.onerror = resolve;
          document.head.append(clone);
        });
      });

      await Promise.all(scriptLoads);
    };

    const initReplacement = (replacement) => {
      window.ThemeInitCollectionCatalogs?.(replacement);
      window.ThemeInitSearchCatalogs?.(replacement);
    };

    const replaceCatalogFromDocument = async (catalog, targetUrl, pushState = true) => {
      try {
        const response = await fetch(targetUrl.href, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          return false;
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const replacement = doc.querySelector('.collection-catalog[data-ajax-catalog], .search-catalog[data-ajax-catalog]');

        if (!replacement) {
          return false;
        }

        await loadCatalogAssets(doc);
        document.title = doc.title;
        catalog.replaceWith(replacement);

        if (pushState) {
          window.history.pushState({ ajaxCatalog: true }, '', targetUrl.href);
        }

        initReplacement(replacement);
        return true;
      } catch (error) {
        return false;
      }
    };

    const replaceCatalog = async (catalog, nextUrl, pushState = true) => {
      const sectionId = catalog.dataset.sectionId;
      const targetUrl = new URL(nextUrl, window.location.href);

      if (!sectionId || targetUrl.origin !== window.location.origin) {
        return false;
      }

      const requestUrl = new URL(targetUrl.href);
      requestUrl.searchParams.set('section_id', sectionId);
      catalog.classList.add('is-loading');

      try {
        const response = await fetch(requestUrl.href, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          return replaceCatalogFromDocument(catalog, targetUrl, pushState);
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const replacement =
          Array.from(doc.querySelectorAll(catalogSelector)).find((element) => element.dataset.sectionId === sectionId) ||
          doc.querySelector(catalogSelector);

        if (!replacement) {
          return replaceCatalogFromDocument(catalog, targetUrl, pushState);
        }

        catalog.replaceWith(replacement);

        if (pushState) {
          window.history.pushState({ ajaxCatalog: true }, '', targetUrl.href);
        }

        initReplacement(replacement);
        return true;
      } catch (error) {
        return replaceCatalogFromDocument(catalog, targetUrl, pushState);
      } finally {
        catalog.classList.remove('is-loading');
      }
    };

    const initCatalog = (catalog) => {
      if (!catalog || initializedCatalogs.has(catalog)) return;
      initializedCatalogs.add(catalog);

      const filterPanel = catalog.querySelector('[data-filter-panel]');
      const filterToggle = catalog.querySelector('[data-filter-toggle]');
      const filterClose = catalog.querySelector('[data-filter-close]');
      const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      const initFilterAccordions = () => {
        catalog.querySelectorAll('[data-filter-group]').forEach((details) => {
          const summary = details.querySelector('[data-filter-summary]');
          const content = details.querySelector('[data-filter-content]');

          if (!summary || !content) return;

          summary.addEventListener('click', (event) => {
            event.preventDefault();

            const shouldOpen = !details.open;

            if (reduceMotionQuery.matches) {
              details.open = shouldOpen;
              return;
            }

            content.getAnimations().forEach((animation) => {
              animation.cancel();
            });

            details.classList.add('is-animating');

            if (shouldOpen) {
              details.open = true;

              const targetHeight = content.scrollHeight;
              const animation = content.animate(
                [
                  { height: '0px', opacity: 0, transform: 'translateY(-4px)' },
                  { height: `${targetHeight}px`, opacity: 1, transform: 'translateY(0)' },
                ],
                {
                  duration: 200,
                  easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
                }
              );

              animation.onfinish = () => {
                details.classList.remove('is-animating');
              };

              animation.oncancel = () => {
                details.classList.remove('is-animating');
              };

              return;
            }

            const startHeight = content.offsetHeight;
            const animation = content.animate(
              [
                { height: `${startHeight}px`, opacity: 1, transform: 'translateY(0)' },
                { height: '0px', opacity: 0, transform: 'translateY(-4px)' },
              ],
              {
                duration: 180,
                easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
              }
            );

            animation.onfinish = () => {
              details.open = false;
              details.classList.remove('is-animating');
            };

            animation.oncancel = () => {
              details.classList.remove('is-animating');
            };
          });
        });
      };

      initFilterAccordions();

      if (filterPanel && filterToggle) {
        const drawerQuery = window.matchMedia('(max-width: 980px)');
        const setOpen = (isOpen) => {
          filterPanel.classList.toggle('is-open', isOpen);
          filterToggle.setAttribute('aria-expanded', String(isOpen));
        };

        filterToggle.addEventListener('click', () => {
          if (!drawerQuery.matches) {
            filterPanel.scrollIntoView({ block: 'nearest' });
            return;
          }

          setOpen(!filterPanel.classList.contains('is-open'));
        });

        filterClose?.addEventListener('click', () => {
          setOpen(false);
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            setOpen(false);
          }
        });

        const syncFilterMode = () => {
          if (!drawerQuery.matches) {
            setOpen(false);
          }
        };

        if (drawerQuery.addEventListener) {
          drawerQuery.addEventListener('change', syncFilterMode);
        } else {
          drawerQuery.addListener(syncFilterMode);
        }

        syncFilterMode();
      }

      catalog.addEventListener('click', async (event) => {
        const link = event.target.closest('a');
        if (
          !link ||
          event.defaultPrevented ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          link.target
        ) {
          return;
        }

        if (
          !link.closest(
            '.collection-catalog__category-nav, .collection-catalog__active-filters, .collection-catalog__filter-actions, .collection-catalog__pagination'
          )
        ) {
          return;
        }

        event.preventDefault();
        const handled = await replaceCatalog(catalog, link.href);
        if (!handled) {
          window.location.href = link.href;
        }
      });

      catalog.addEventListener('submit', async (event) => {
        const form = event.target.closest('form');
        if (!form || form.closest('.collection-product-card__form')) return;

        if (!form.closest('[data-filter-panel], .collection-catalog__sort')) {
          return;
        }

        event.preventDefault();
        const nextUrl = getFormUrl(form);
        const handled = await replaceCatalog(catalog, nextUrl);
        if (!handled) {
          window.location.href = nextUrl;
        }
      });

      catalog.querySelectorAll('[data-sort-select]').forEach((select) => {
        select.addEventListener('change', () => {
          select.form?.requestSubmit();
        });
      });
    };

    window.ThemeInitCollectionCatalogs = (root = document) => {
      if (root.matches?.(catalogSelector)) {
        initCatalog(root);
      }

      root.querySelectorAll?.(catalogSelector).forEach(initCatalog);
    };

    window.addEventListener('popstate', () => {
      const catalog = document.querySelector(catalogSelector);
      if (!catalog) return;
      replaceCatalog(catalog, window.location.href, false);
    });

    document.addEventListener('shopify:section:load', (event) => {
      window.ThemeInitCollectionCatalogs(event.target);
    });

    window.ThemeInitCollectionCatalogs();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-help-center"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-help-center-search]').forEach((form) => {
    if (form.dataset.helpCenterSearchInitialized === 'true') return;
    form.dataset.helpCenterSearchInitialized = 'true';

    const section = form.closest('.help-center');
    const input = form.querySelector('[data-help-center-search-input]');
    const status = section?.querySelector('[data-help-center-search-status]');
    const items = Array.from(section?.querySelectorAll('[data-help-center-search-item]') || []);
    const groups = Array.from(section?.querySelectorAll('[data-help-center-search-group]') || []);

    if (!section || !input || !items.length) return;

    const normalize = (value) => value.toLowerCase().replace(/\s+/g, ' ').trim();

    const update = () => {
      const query = normalize(input.value || '');
      let visibleCount = 0;

      items.forEach((item) => {
        const text = normalize(item.dataset.helpCenterSearchText || item.textContent || '');
        const matches = !query || text.includes(query);
        item.hidden = !matches;

        if (matches) {
          visibleCount += 1;

          if (query && item.matches('details')) {
            item.open = true;
          }
        }
      });

      groups.forEach((group) => {
        const hasVisibleItem = Array.from(group.querySelectorAll('[data-help-center-search-item]')).some((item) => !item.hidden);
        group.hidden = !hasVisibleItem;
      });

      if (!status) return;

      if (!query || visibleCount > 0) {
        status.hidden = true;
        status.textContent = '';
        return;
      }

      status.textContent = status.dataset.emptyMessage || 'No matching help topics found.';
      status.hidden = false;
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      update();
    });

    input.addEventListener('input', update);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    if (section.dataset.productInitialized === 'true') return;
    section.dataset.productInitialized = 'true';

    const mainImage = section.querySelector('[data-product-main-image]');

    const setActiveThumb = (imageId, imageSrc) => {
      section.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
        const isCurrent =
          (imageId && thumb.dataset.productImageId === imageId) ||
          (imageSrc && thumb.dataset.productImageSrc === imageSrc);

        thumb.classList.toggle('is-active', isCurrent);
        thumb.setAttribute('aria-selected', String(isCurrent));
      });
    };

    section.querySelectorAll('[data-product-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (mainImage) {
          mainImage.src = button.dataset.productImageSrc;
          mainImage.alt = button.dataset.productImageAlt || '';
        }

        setActiveThumb(button.dataset.productImageId, button.dataset.productImageSrc);
      });
    });

    const variantSelect = section.querySelector('[data-product-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-product-compare-price]');
    const stock = section.querySelector('[data-product-stock]');
    const stockWrap = section.querySelector('.product-detail__stock');
    const addButton = section.querySelector('[data-product-add]');
    const selection = section.querySelector('[data-product-selection]');
    const optionGroups = Array.from(section.querySelectorAll('[data-product-option-index]'));
    const stockThreshold = Number(section.dataset.stockThreshold || 10);
    const selectedLabel = section.dataset.selectedLabel || 'Selected';

    const getSelectionText = (option) => {
      const values = option.dataset.options ? option.dataset.options.split('||') : [];

      if (optionGroups.length === 1) {
        return `${selectedLabel}: ${values[0] || option.textContent.trim()}`;
      }

      if (optionGroups.length > 1) {
        return `${selectedLabel}: ${values.join(' / ')}`;
      }

      return option.textContent.trim();
    };

    const updateVariant = (option) => {
      if (!option) return;

      if (variantSelect) {
        variantSelect.value = option.value;
      }

      if (price) {
        price.textContent = option.dataset.price;
      }

      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.hidden = option.dataset.hasComparePrice !== 'true';
      }

      const available = option.dataset.available === 'true';
      const inventory = Number(option.dataset.inventory || 0);

      if (stock) {
        if (available && inventory > stockThreshold) {
          stock.textContent = `${stockThreshold}+ ${section.dataset.inStockLabel}`;
        } else if (available && inventory > 0) {
          stock.textContent = `${inventory} ${section.dataset.inStockLabel}`;
        } else {
          stock.textContent = available ? section.dataset.inStockLabel : section.dataset.outOfStockLabel;
        }
      }

      if (stockWrap) {
        stockWrap.classList.toggle('is-unavailable', !available);
      }

      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
      }

      if (mainImage && option.dataset.imageSrc) {
        mainImage.src = option.dataset.imageSrc;
        mainImage.alt = option.dataset.imageAlt || mainImage.alt || '';
        setActiveThumb(option.dataset.imageId, option.dataset.imageSrc);
      }

      const values = option.dataset.options ? option.dataset.options.split('||') : [];

      optionGroups.forEach((group, index) => {
        group.querySelectorAll('[data-product-option-value]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.productOptionValue === values[index]));
        });
      });

      if (selection) {
        selection.textContent = getSelectionText(option);
      }
    };

    if (variantSelect) {
      updateVariant(variantSelect.selectedOptions[0]);

      variantSelect.addEventListener('change', () => {
        updateVariant(variantSelect.selectedOptions[0]);
      });
    }

    section.querySelectorAll('[data-product-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-product-option-index]');

        if (group) {
          group.querySelectorAll('[data-product-option-value]').forEach((optionButton) => {
            optionButton.setAttribute('aria-pressed', String(optionButton === button));
          });
        }

        if (!variantSelect) return;

        const selectedValues = optionGroups.map((optionGroup) => {
          const selected = optionGroup.querySelector('[data-product-option-value][aria-pressed="true"]');
          return selected ? selected.dataset.productOptionValue : '';
        });

        const match = Array.from(variantSelect.options).find((option) => {
          const optionValues = option.dataset.options ? option.dataset.options.split('||') : [];
          return optionValues.length === selectedValues.length && optionValues.every((value, index) => value === selectedValues[index]);
        });

        updateVariant(match);
      });
    });

    section.querySelectorAll('[data-product-quantity-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = section.querySelector('[data-product-quantity]');
        if (!input) return;

        const step = Number(button.dataset.productQuantityStep);
        const current = Number(input.value || 1);
        input.value = Math.max(1, current + step);
      });
    });

    section.querySelectorAll('[data-product-tab]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.productTab;

        section.querySelectorAll('[data-product-tab]').forEach((tab) => {
          const isCurrent = tab === button;
          tab.classList.toggle('is-active', isCurrent);
          tab.setAttribute('aria-selected', String(isCurrent));
        });

        section.querySelectorAll('[data-product-tab-panel]').forEach((panel) => {
          const isCurrent = panel.dataset.productTabPanel === target;
          panel.hidden = !isCurrent;
          panel.classList.toggle('is-active', isCurrent);
        });

        if (target === 'reviews') {
          window.dispatchEvent(new Event('resize'));
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (() => {
    const catalogSelector = '.search-catalog[data-ajax-catalog]';
    const initializedCatalogs = new WeakSet();

    const getFormUrl = (form) => {
      const url = new URL(form.getAttribute('action') || window.location.href, window.location.href);
      url.search = new URLSearchParams(new FormData(form)).toString();
      return url.href;
    };

    const loadCatalogAssets = async (doc) => {
      doc.querySelectorAll('link[rel="stylesheet"][href*="compiled_assets/styles.css"]').forEach((link) => {
        const href = link.href;
        if (!href || document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) return;
        document.head.append(link.cloneNode(false));
      });

      const scriptLoads = Array.from(doc.querySelectorAll('script[src*="compiled_assets/scripts.js"]')).map((script) => {
        const src = script.src;
        if (!src || document.querySelector(`script[src="${src}"]`)) {
          return Promise.resolve();
        }

        return new Promise((resolve) => {
          const clone = document.createElement('script');
          clone.src = src;
          clone.async = false;
          clone.onload = resolve;
          clone.onerror = resolve;
          document.head.append(clone);
        });
      });

      await Promise.all(scriptLoads);
    };

    const initReplacement = (replacement) => {
      window.ThemeInitSearchCatalogs?.(replacement);
      window.ThemeInitCollectionCatalogs?.(replacement);
    };

    const replaceCatalogFromDocument = async (catalog, targetUrl, pushState = true) => {
      try {
        const response = await fetch(targetUrl.href, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          return false;
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const replacement = doc.querySelector('.search-catalog[data-ajax-catalog], .collection-catalog[data-ajax-catalog]');

        if (!replacement) {
          return false;
        }

        await loadCatalogAssets(doc);
        document.title = doc.title;
        catalog.replaceWith(replacement);

        if (pushState) {
          window.history.pushState({ ajaxCatalog: true }, '', targetUrl.href);
        }

        initReplacement(replacement);
        return true;
      } catch (error) {
        return false;
      }
    };

    const replaceCatalog = async (catalog, nextUrl, pushState = true) => {
      const sectionId = catalog.dataset.sectionId;
      const targetUrl = new URL(nextUrl, window.location.href);

      if (!sectionId || targetUrl.origin !== window.location.origin) {
        return false;
      }

      const requestUrl = new URL(targetUrl.href);
      requestUrl.searchParams.set('section_id', sectionId);
      catalog.classList.add('is-loading');

      try {
        const response = await fetch(requestUrl.href, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          return replaceCatalogFromDocument(catalog, targetUrl, pushState);
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const replacement =
          Array.from(doc.querySelectorAll(catalogSelector)).find((element) => element.dataset.sectionId === sectionId) ||
          doc.querySelector(catalogSelector);

        if (!replacement) {
          return replaceCatalogFromDocument(catalog, targetUrl, pushState);
        }

        catalog.replaceWith(replacement);

        if (pushState) {
          window.history.pushState({ ajaxCatalog: true }, '', targetUrl.href);
        }

        initReplacement(replacement);
        return true;
      } catch (error) {
        return replaceCatalogFromDocument(catalog, targetUrl, pushState);
      } finally {
        catalog.classList.remove('is-loading');
      }
    };

    const initCatalog = (catalog) => {
      if (!catalog || initializedCatalogs.has(catalog)) return;
      initializedCatalogs.add(catalog);

      const filterPanel = catalog.querySelector('[data-filter-panel]');
      const filterToggle = catalog.querySelector('[data-filter-toggle]');
      const filterClose = catalog.querySelector('[data-filter-close]');
      const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      const initFilterAccordions = () => {
        catalog.querySelectorAll('[data-filter-group]').forEach((details) => {
          const summary = details.querySelector('[data-filter-summary]');
          const content = details.querySelector('[data-filter-content]');

          if (!summary || !content) return;

          summary.addEventListener('click', (event) => {
            event.preventDefault();

            const shouldOpen = !details.open;

            if (reduceMotionQuery.matches) {
              details.open = shouldOpen;
              return;
            }

            content.getAnimations().forEach((animation) => {
              animation.cancel();
            });

            details.classList.add('is-animating');

            if (shouldOpen) {
              details.open = true;

              const targetHeight = content.scrollHeight;
              const animation = content.animate(
                [
                  { height: '0px', opacity: 0, transform: 'translateY(-4px)' },
                  { height: `${targetHeight}px`, opacity: 1, transform: 'translateY(0)' },
                ],
                {
                  duration: 200,
                  easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
                }
              );

              animation.onfinish = () => {
                details.classList.remove('is-animating');
              };

              animation.oncancel = () => {
                details.classList.remove('is-animating');
              };

              return;
            }

            const startHeight = content.offsetHeight;
            const animation = content.animate(
              [
                { height: `${startHeight}px`, opacity: 1, transform: 'translateY(0)' },
                { height: '0px', opacity: 0, transform: 'translateY(-4px)' },
              ],
              {
                duration: 180,
                easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
              }
            );

            animation.onfinish = () => {
              details.open = false;
              details.classList.remove('is-animating');
            };

            animation.oncancel = () => {
              details.classList.remove('is-animating');
            };
          });
        });
      };

      initFilterAccordions();

      if (filterPanel && filterToggle) {
        const drawerQuery = window.matchMedia('(max-width: 980px)');
        const setOpen = (isOpen) => {
          filterPanel.classList.toggle('is-open', isOpen);
          filterToggle.setAttribute('aria-expanded', String(isOpen));
        };

        filterToggle.addEventListener('click', () => {
          if (!drawerQuery.matches) {
            filterPanel.scrollIntoView({ block: 'nearest' });
            return;
          }

          setOpen(!filterPanel.classList.contains('is-open'));
        });

        filterClose?.addEventListener('click', () => {
          setOpen(false);
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            setOpen(false);
          }
        });

        const syncFilterMode = () => {
          if (!drawerQuery.matches) {
            setOpen(false);
          }
        };

        if (drawerQuery.addEventListener) {
          drawerQuery.addEventListener('change', syncFilterMode);
        } else {
          drawerQuery.addListener(syncFilterMode);
        }

        syncFilterMode();
      }

      catalog.addEventListener('click', async (event) => {
        const link = event.target.closest('a');
        if (
          !link ||
          event.defaultPrevented ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          link.target
        ) {
          return;
        }

        if (
          !link.closest(
            '.collection-catalog__category-nav, .collection-catalog__active-filters, .collection-catalog__filter-actions, .collection-catalog__pagination'
          )
        ) {
          return;
        }

        event.preventDefault();
        const handled = await replaceCatalog(catalog, link.href);
        if (!handled) {
          window.location.href = link.href;
        }
      });

      catalog.addEventListener('submit', async (event) => {
        const form = event.target.closest('form');
        if (!form || form.closest('.collection-product-card__form')) return;

        if (!form.closest('[data-filter-panel], .collection-catalog__sort, .search-catalog__stock-toggle')) {
          return;
        }

        event.preventDefault();
        const nextUrl = getFormUrl(form);
        const handled = await replaceCatalog(catalog, nextUrl);
        if (!handled) {
          window.location.href = nextUrl;
        }
      });

      catalog.querySelectorAll('[data-sort-select]').forEach((select) => {
        select.addEventListener('change', () => {
          select.form?.requestSubmit();
        });
      });

      catalog.querySelectorAll('[data-stock-toggle]').forEach((toggle) => {
        toggle.addEventListener('change', () => {
          toggle.form?.requestSubmit();
        });
      });
    };

    window.ThemeInitSearchCatalogs = (root = document) => {
      if (root.matches?.(catalogSelector)) {
        initCatalog(root);
      }

      root.querySelectorAll?.(catalogSelector).forEach(initCatalog);
    };

    window.addEventListener('popstate', () => {
      const catalog = document.querySelector(catalogSelector);
      if (!catalog) return;
      replaceCatalog(catalog, window.location.href, false);
    });

    document.addEventListener('shopify:section:load', (event) => {
      window.ThemeInitSearchCatalogs(event.target);
    });

    window.ThemeInitSearchCatalogs();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageFor = (frequency) => (frequency === 'forever' ? window.localStorage : window.sessionStorage);

    const openPopup = (dialog, force = false) => {
      if (!dialog || dialog.open) return;

      const enabled = dialog.dataset.enabled === 'true';
      const key = dialog.dataset.storageKey;
      const storage = storageFor(dialog.dataset.frequency);

      if (!force) {
        if (!enabled) return;
        if (key && storage.getItem(key) === 'dismissed') return;
      }

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      dialog.focus({ preventScroll: true });
    };

    const closePopup = (dialog) => {
      if (!dialog) return;

      const key = dialog.dataset.storageKey;
      if (key) {
        storageFor(dialog.dataset.frequency).setItem(key, 'dismissed');
      }

      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    const initPromoPopups = () => {
      document.querySelectorAll('[data-promo-popup]').forEach((dialog) => {
        if (dialog.dataset.initialized === 'true') return;
        dialog.dataset.initialized = 'true';

        dialog.querySelectorAll('[data-promo-popup-close]').forEach((button) => {
          button.addEventListener('click', () => closePopup(dialog));
        });

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            closePopup(dialog);
          }
        });

        const delay = Number(dialog.dataset.delay || 0);
        window.setTimeout(() => openPopup(dialog), delay);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPromoPopups);
    } else {
      initPromoPopups();
    }

    document.addEventListener('shopify:section:load', initPromoPopups);
    document.addEventListener('shopify:section:select', (event) => {
      const dialog = event.target.querySelector('[data-promo-popup]');
      if (dialog) openPopup(dialog, true);
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      const dialog = event.target.querySelector('[data-promo-popup]');
      if (dialog && dialog.open) dialog.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-slideshow]').forEach((carousel) => {
    const track = carousel.querySelector('.slideshow__track');
    const viewport = carousel.querySelector('.slideshow__viewport');
    const slides = Array.from(carousel.querySelectorAll('[data-slideshow-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-slideshow-dot]'));
    const prevButton = carousel.querySelector('[data-slideshow-prev]');
    const nextButton = carousel.querySelector('[data-slideshow-next]');
    const autoplay = carousel.dataset.autoplay === 'true';
    const interval = Number(carousel.dataset.interval || 5000);
    const mobileQuery = window.matchMedia('(max-width: 760px)');
    let activeIndex = 0;
    let autoplayTimer = null;
    let dragStartX = 0;
    let dragDeltaX = 0;
    let isDragging = false;
    let suppressClick = false;
    let isForwardWrapping = false;
    let forwardWrapFallbackTimer = null;

    if (!track || !viewport || slides.length <= 1) return;

    const firstSlideClone = slides[0].cloneNode(true);
    firstSlideClone.removeAttribute('id');
    firstSlideClone.setAttribute('aria-hidden', 'true');
    firstSlideClone.dataset.slideshowClone = 'true';
    firstSlideClone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
    firstSlideClone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
      element.setAttribute('tabindex', '-1');
    });
    track.append(firstSlideClone);

    const updateSlideState = () => {
      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    };

    const setTrackIndex = (index, instant = false) => {
      track.classList.toggle('is-resetting', instant);
      track.style.setProperty('--slideshow-active-index', index);

      if (instant) {
        track.offsetHeight;
        track.classList.remove('is-resetting');
      }
    };

    const finishForwardWrap = () => {
      if (!isForwardWrapping) return;

      if (forwardWrapFallbackTimer) {
        window.clearTimeout(forwardWrapFallbackTimer);
        forwardWrapFallbackTimer = null;
      }

      setTrackIndex(0, true);
      isForwardWrapping = false;
    };

    const goToSlide = (nextIndex) => {
      if (isForwardWrapping) return;

      const isForwardWrap = nextIndex >= slides.length;
      const isBackwardWrap = nextIndex < 0;

      if (isForwardWrap) {
        activeIndex = 0;
        isForwardWrapping = true;
        setTrackIndex(slides.length);
        updateSlideState();

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.requestAnimationFrame(() => {
            finishForwardWrap();
          });
        } else {
          forwardWrapFallbackTimer = window.setTimeout(finishForwardWrap, 520);
        }

        return;
      }

      if (isBackwardWrap) {
        activeIndex = slides.length - 1;
        setTrackIndex(activeIndex);
        updateSlideState();
        return;
      }

      activeIndex = nextIndex;
      setTrackIndex(activeIndex);
      updateSlideState();
    };

    goToSlide(0);

    track.addEventListener('transitionend', (event) => {
      if (event.target !== track || event.propertyName !== 'transform') return;
      if (activeIndex !== 0) return;

      const currentTrackIndex = Number(
        getComputedStyle(track).getPropertyValue('--slideshow-active-index').trim() || 0
      );

      if (currentTrackIndex === slides.length) {
        finishForwardWrap();
      }
    });

    const stopAutoplay = () => {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    const startAutoplay = () => {
      if (!autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(() => goToSlide(activeIndex + 1), interval);
    };

    prevButton?.addEventListener('click', () => {
      stopAutoplay();
      goToSlide(activeIndex - 1);
      startAutoplay();
    });

    nextButton?.addEventListener('click', () => {
      stopAutoplay();
      goToSlide(activeIndex + 1);
      startAutoplay();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        stopAutoplay();
        goToSlide(Number(dot.dataset.slideshowDot));
        startAutoplay();
      });
    });

    viewport.addEventListener('pointerdown', (event) => {
      if (!mobileQuery.matches || event.button !== 0) return;
      isDragging = true;
      dragStartX = event.clientX;
      dragDeltaX = 0;
      viewport.setPointerCapture?.(event.pointerId);
      stopAutoplay();
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!isDragging) return;
      dragDeltaX = event.clientX - dragStartX;
    });

    const finishDrag = () => {
      if (!isDragging) return;

      const threshold = Math.min(72, viewport.clientWidth * 0.2);
      const shouldSlide = Math.abs(dragDeltaX) > threshold;

      if (shouldSlide) {
        suppressClick = true;
        if (dragDeltaX < 0) {
          goToSlide(activeIndex + 1);
        } else {
          goToSlide(activeIndex - 1);
        }
        window.setTimeout(() => {
          suppressClick = false;
        }, 120);
      }

      isDragging = false;
      dragStartX = 0;
      dragDeltaX = 0;
      startAutoplay();
    };

    viewport.addEventListener('pointerup', finishDrag);
    viewport.addEventListener('pointercancel', finishDrag);
    viewport.addEventListener('lostpointercapture', finishDrag);
    viewport.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();
})();
